import { render } from "./LoadingProgressBar.vue?vue&type=template&id=2dbd8add&scoped=true"
import script from "./LoadingProgressBar.vue?vue&type=script&lang=js"
export * from "./LoadingProgressBar.vue?vue&type=script&lang=js"

import "./LoadingProgressBar.vue?vue&type=style&index=0&id=2dbd8add&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbd8add"]])

export default __exports__